<!-- 地理坐标/地图 -->
<template>
    <div class="width_height_100" :id="id"></div>
</template>
<script>
import * as echarts from "echarts";
import chinaMap from "@/common/map/china.json";
export default {
    name: "echartMap",
    data() {
        return {
        };
    },
    props: {
        id: {
            type: String,
            default: "line",
        },
        min: {
            type: Number,
            default: 0,
        },
        max: {
            type: Number,
            default: 0,
        },
        data: {
            type: Array,
            default: function () {
                return [
                    { value: 0, name: "北京" },
                ];
            },
        },
    },
    mounted() {
        this.initPie();
    },
    methods: {
        initPie() {
            echarts.registerMap("china", { geoJSON: chinaMap });
            let chartDom = document.getElementById(this.id);
            let myChart = echarts.init(chartDom);
            let option;
            option = {
                tooltip: {
                    show: true,
                },
                series: [
                    {
                        name: "",
                        type: "map",
                        map: "china",
                        data: this.data,
                        label: {
                            show: true,
                            fontSize: 8,
                            color: "#999",
                        },
                    },
                ],
                visualMap: {
                    show: true,
                    min: this.min,
                    max: this.max,
                    inRange: {
                        color: [
                            '#ffffff',
                            "#313695",
                            "#4575b4",
                            "#74add1",
                            "#abd9e9",
                            "#e0f3f8",
                            "#ffffbf",
                            "#fee090",
                            "#fdae61",
                            "#f46d43",
                            "#d73027",
                            "#a50026",
                        ],
                    },
                    calculable: true,
                },
            };
            option && myChart.setOption(option);
        },
    },
};
</script>

<style scoped>
.width_height_100 {
    width: 100%;
    height: 100%;
}
</style>